import React from 'react';
import { Camera, ChevronRight } from 'lucide-react';

const EMPTY_ACTIONS = [];

export default function InspirationPersonaliseCta({
  onClick,
  title = 'Adapt this look to me',
  detail = 'Add my skin for a personal colour match',
  secondaryActions = EMPTY_ACTIONS,
}) {
  return (
    <div className="mt-3 w-full max-w-md">
      <button
        type="button"
        onClick={onClick}
        className="flex w-full items-center gap-3 rounded-2xl border border-[#D8CBC1] bg-[#FCF8F4] p-4 text-left text-[#2D1515]"
      >
        <span className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-[#F3E8DE] text-[#764530]"><Camera size={20} aria-hidden="true" /></span>
        <span className="min-w-0 flex-1"><strong className="block text-[15px]">{title}</strong><small className="mt-1 block leading-snug text-[#786B65]">{detail}</small></span>
        <ChevronRight size={18} aria-hidden="true" />
      </button>
      {secondaryActions.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {secondaryActions.map((action) => (
            <button key={action.label} type="button" onClick={action.onClick} className="rounded-full border border-[#D8CBC1] bg-white px-3 py-2 text-[13px] font-medium text-[#2D1515]">
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
